import { Sites } from '@ps/platform-message-framework/common/Sites';
import {
  NAME_AND_CITY_NOT_ALLOWED_SYMBOLS,
  mustNotContainNumber,
  mustNotContainSymbols,
  noWhiteStartOrEnd
} from '@ps/web-shared-validators';
import React from 'react';
import { useField } from 'react-final-form';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import TextInput from '../../../../../TextInput/TextInput';

import {
  TXTCLI_Optional,
  TXTWCL_Alias,
  TXTWCL_The_alias_you_have_entered_is__ELL
} from './Alias.messages.json';

export const aliasFieldName = 'nameAlias';

const Alias = () => {
  const { formatMessage } = useIntl();
  const isCAON = useSelector(select.cms.getSiteId) === Sites.CA_ON;
  const {
    input: { value }
  } = useField(aliasFieldName, { subscription: { value: true } });

  return isCAON ? (
    <TextInput
      id={aliasFieldName}
      value={value}
      maxLength={50}
      label={TXTWCL_Alias}
      placeholder={formatMessage(TXTCLI_Optional)}
      checkDisabled
      validators={[
        noWhiteStartOrEnd,
        mustNotContainNumber(TXTWCL_The_alias_you_have_entered_is__ELL, true),
        mustNotContainSymbols(
          NAME_AND_CITY_NOT_ALLOWED_SYMBOLS,
          TXTWCL_The_alias_you_have_entered_is__ELL
        )
      ]}
    />
  ) : null;
};

export default Alias;
